import { formatMoneyDisplay, isMoneyString, roundMoney } from '@finvox/shared/money';
import { useCallback } from 'react';

export function useFormatMoney() {
  return useCallback((value: string | null | undefined, fallback = '—') => {
    if (value == null || value === '' || value === fallback) return fallback;
    if (typeof value !== 'string') return fallback;
    const trimmed = value.trim();
    if (!trimmed || trimmed === '—') return fallback;
    if (!isMoneyString(trimmed) && !/^-?\d+$/.test(trimmed)) return trimmed;
    try {
      return formatMoneyDisplay(roundMoney(trimmed));
    } catch {
      return trimmed;
    }
  }, []);
}
